import type { IToast } from "@efesto-cloud/toast";
import { useEffect } from "react";
import { toast } from "react-hot-toast";

export default function useToaster(data?: IToast<unknown, unknown>) {
    useEffect(() => {
        if (data) {
            if (data.success) toast.success(data.message);
            else toast.error(data.message);
        }
    }, [data]);
}
